import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { deleteWorkStatus, DeleteWorkStatusResponse } from '../api/deleteWorkStatus';
import { ApiError } from 'types/apiError';
import { QUERY_KEYS } from 'service/querykeys';

export const useDeleteWorkStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<DeleteWorkStatusResponse, ApiError, { projectUuid: string; workStatusUuid: string }>({
    mutationFn: ({ projectUuid, workStatusUuid }) => deleteWorkStatus(projectUuid, workStatusUuid),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.PROJECT_DEFAULTS(variables.projectUuid),
      });
      toast.success('Column deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to delete column');
    },
  });
};
